var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200mm",
    height: "60mm",
    viewBox: "0 0 200 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 17.3,
    x2: 27.46,
    y1: 191.82,
    y2: 181.66,
    gradientTransform: "matrix(1.36248 0 0 -1.36248 -4.523 500.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 34.83,
    x2: 12.07,
    y1: 169.7,
    y2: 146.95,
    gradientTransform: "matrix(1.36248 0 0 -1.36248 -4.523 500.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 43.83,
    x2: 19.64,
    y1: 172,
    y2: 172,
    gradientTransform: "matrix(1.36248 0 0 -1.36248 -4.523 500.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 31.8,
    x2: 15.02,
    y1: 183.29,
    y2: 166.51,
    gradientTransform: "matrix(1.36248 0 0 -1.36248 -4.523 500.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -237)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.439 237.811h152.032v58.851H.439z",
    className: "cls-1",
    style: {
      fill: "#fff",
      fillOpacity: 0,
      strokeWidth: 0.98085326
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 198.873,
    height: 58.925,
    x: 0.439,
    y: 237.737,
    rx: 7.366,
    ry: 7.366,
    style: {
      strokeWidth: 1.47313476
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.946 238.915a6.187 6.187 0 0 1 6.187 6.187v44.194a6.187 6.187 0 0 1-6.187 6.188H7.804a6.187 6.187 0 0 1-6.187-6.188v-44.194a6.187 6.187 0 0 1 6.187-6.187h184.142m0-1.178H7.804a7.366 7.366 0 0 0-7.365 7.365v44.194a7.366 7.366 0 0 0 7.365 7.366h184.142a7.366 7.366 0 0 0 7.366-7.366v-44.194a7.366 7.366 0 0 0-7.366-7.365z",
    className: "cls-2",
    style: {
      fill: "#a6a6a6",
      strokeWidth: 1.47313476
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.71 253.192a3.692 3.692 0 0 1-1.022 2.725 3.965 3.965 0 0 1-2.997 1.212 4.292 4.292 0 0 1-3.011-7.316 4.087 4.087 0 0 1 3.01-1.226 4.224 4.224 0 0 1 1.677.34 3.365 3.365 0 0 1 1.28.913l-.722.722a2.725 2.725 0 0 0-2.234-.967 3.16 3.16 0 0 0-3.175 3.27 3.215 3.215 0 0 0 5.45 2.357 2.575 2.575 0 0 0 .681-1.662h-2.956v-.981h3.965a3.46 3.46 0 0 1 .054.613zM79.95 249.786h-3.678v2.588h3.351v.981h-3.351v2.59h3.678v1.007h-4.768v-8.175h4.768zM84.42 256.952h-1.05v-7.166h-2.289v-1.009h5.682v1.009h-2.344zM90.768 256.952v-8.175h1.05v8.175zM96.477 256.952h-1.05v-7.166H93.14v-1.009h5.613v1.009h-2.275zM109.393 255.89a4.25 4.25 0 0 1-5.995 0 4.414 4.414 0 0 1 0-6.063 4.224 4.224 0 0 1 5.995 0 4.4 4.4 0 0 1 0 6.063zm-5.218-.682a3.147 3.147 0 0 0 4.442 0 3.488 3.488 0 0 0 0-4.687 3.147 3.147 0 0 0-4.442 0 3.488 3.488 0 0 0 0 4.687zM112.077 256.952v-8.175h1.281l3.978 6.363v-6.363h1.036v8.175h-1.09l-4.156-6.662v6.662z",
    className: "cls-3",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: ".27249509px",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.94 268.874a5.79 5.79 0 1 0 5.818 5.79 5.709 5.709 0 0 0-5.817-5.79zm0 9.306a3.515 3.515 0 1 1 3.27-3.515 3.352 3.352 0 0 1-3.27 3.515zm-12.684-9.306a5.79 5.79 0 1 0 5.804 5.79 5.709 5.709 0 0 0-5.818-5.79zm0 9.306a3.515 3.515 0 1 1 3.256-3.515 3.352 3.352 0 0 1-3.27 3.515zm-15.11-7.521v2.452h5.886a5.137 5.137 0 0 1-1.363 3.093 6.022 6.022 0 0 1-4.537 1.799 6.54 6.54 0 0 1 0-13.08 6.267 6.267 0 0 1 4.456 1.757l1.73-1.73a8.57 8.57 0 0 0-6.172-2.548 9.006 9.006 0 1 0 0 17.999 8.175 8.175 0 0 0 6.281-2.521 8.175 8.175 0 0 0 2.126-5.75 7.998 7.998 0 0 0-.137-1.54h-8.27zm61.734 1.907a5.45 5.45 0 0 0-4.96-3.692 5.45 5.45 0 0 0-5.45 5.79 5.668 5.668 0 0 0 5.75 5.791 5.763 5.763 0 0 0 4.823-2.561l-1.975-1.363a3.31 3.31 0 0 1-2.848 1.608 2.943 2.943 0 0 1-2.807-1.758l7.753-3.202zm-7.903 1.935a3.175 3.175 0 0 1 3.025-3.379 2.248 2.248 0 0 1 2.153 1.226zm-6.294 5.613h2.548v-17.03h-2.548zm-4.17-9.946h-.095a4.087 4.087 0 0 0-3.052-1.362 5.804 5.804 0 0 0 0 11.595 3.951 3.951 0 0 0 3.052-1.363h.082v.94c0 2.221-1.185 3.406-3.093 3.406a3.202 3.202 0 0 1-2.916-2.057l-2.22.927a5.518 5.518 0 0 0 5.136 3.42c2.984 0 5.45-1.758 5.45-6.036v-10.423h-2.343zm-2.915 8.012a3.529 3.529 0 0 1 0-7.03 3.27 3.27 0 0 1 3.093 3.515 3.243 3.243 0 0 1-3.107 3.515zm33.217-15.097h-6.09v17.031h2.548v-6.458h3.556a5.3 5.3 0 1 0-.014-10.573zm0 8.175h-3.556v-5.804h3.61a2.916 2.916 0 1 1 0 5.832zm15.71-2.452a4.769 4.769 0 0 0-4.538 2.602l2.262.94a2.412 2.412 0 0 1 2.316-1.253 2.452 2.452 0 0 1 2.725 2.193v.178a5.627 5.627 0 0 0-2.657-.654c-2.438 0-4.905 1.362-4.905 3.828a3.938 3.938 0 0 0 4.224 3.747 3.583 3.583 0 0 0 3.27-1.635h.082v1.363h2.452v-6.554c0-2.984-2.262-4.714-5.164-4.714zm-.314 9.333a1.771 1.771 0 0 1-1.99-1.444c0-1.363 1.445-1.812 2.726-1.812a4.523 4.523 0 0 1 2.316.572 3.08 3.08 0 0 1-2.984 2.725zm14.483-8.924-2.916 7.384h-.081l-3.025-7.384h-2.725l4.537 10.327-2.589 5.736h2.657l6.976-16.063h-2.82zm-22.903 10.9h2.548v-17.032h-2.548z",
    className: "cls-4",
    style: {
      fill: "#fff",
      strokeWidth: 1.3624754
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.326 249.513a2.725 2.725 0 0 0-.627 1.908v30.138a2.725 2.725 0 0 0 .627 1.907l.095.095 16.881-16.867v-.409l-16.88-16.867z",
    className: "cls-5",
    style: {
      fill: "url(#a)",
      strokeWidth: 1.3624754
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.888 272.321-5.586-5.627v-.409l5.586-5.627.123.069 6.69 3.8c1.907 1.077 1.907 2.848 0 3.938l-6.663 3.788z",
    className: "cls-6",
    style: {
      fill: "url(#b)",
      strokeWidth: 1.3624754
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.052 272.24-5.75-5.75-16.976 16.976a2.22 2.22 0 0 0 2.834.082l19.905-11.309",
    className: "cls-7",
    style: {
      fill: "url(#c)",
      strokeWidth: 1.3624754
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.052 260.74-19.906-11.309a2.22 2.22 0 0 0-2.834.082l16.99 16.977z",
    className: "cls-8",
    style: {
      fill: "url(#d)",
      strokeWidth: 1.3624754
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.888 272.117-19.742 11.24a2.275 2.275 0 0 1-2.725 0l-.095.095.095.096a2.262 2.262 0 0 0 2.725 0l19.906-11.309z",
    className: "cls-9",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      strokeWidth: 1.3624754
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.326 283.275a2.725 2.725 0 0 1-.627-1.907v.204a2.725 2.725 0 0 0 .627 1.908l.095-.096zM52.7 268.26l-6.812 3.857.123.122 6.69-3.787a2.384 2.384 0 0 0 1.362-1.962 2.534 2.534 0 0 1-1.362 1.771z",
    className: "cls-10",
    style: {
      opacity: 0.12000002,
      isolation: "isolate",
      strokeWidth: 1.3624754
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.146 249.622 26.555 15.096a2.534 2.534 0 0 1 1.362 1.772 2.384 2.384 0 0 0-1.362-1.962L26.146 249.43c-1.907-1.076-3.46-.177-3.46 2.003v.205c.04-2.194 1.566-3.093 3.46-2.017z",
    className: "cls-11",
    style: {
      opacity: 0.25,
      isolation: "isolate",
      fill: "#fff",
      strokeWidth: 1.3624754
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.3b63ffed23e243ab7cb39db2f2000e87.svg";
export { ForwardRef as ReactComponent };